import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import "./AdminLogin.css";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("admin_token");
  const from = location.state?.from || "/admin/dashboard";

  // If already logged in, don't show login page
  if (token) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);

    try {
      const res = await axios.post("https://api.thetotetherapy.com/api/auth/login", {
        email,
        password,
      });

      localStorage.setItem("admin_token", res.data.token);

      // go back to the route user originally tried to open
      navigate(from, { replace: true });
    } catch (error) {
      setErr(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminLogin">
      <div className="adminLogin__card">
        <div className="adminLogin__header">
          <img className="adminLogin__logo" src="/Tote.png" alt="Tote Therapy" />
          <h2>Admin Panel</h2>
          <p>Login to manage products & orders.</p>
        </div>

        {err && <div className="adminLogin__error">{err}</div>}

        <form className="adminLogin__form" onSubmit={submit}>
          <label className="adminLogin__label">Email</label>
          <input
            className="adminLogin__input"
            type="email"
            placeholder="admin@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="adminLogin__label">Password</label>
          <input
            className="adminLogin__input"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button className="adminLogin__btn" disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        <div className="adminLogin__footer">
          <span>© {new Date().getFullYear()} Tote Therapy</span>
        </div>
      </div>
    </div>
  );
}